import script from "./DocumentTemplateDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./DocumentTemplateDetails.vue?vue&type=script&lang=ts&setup=true"

import "./DocumentTemplateDetails.vue?vue&type=style&index=0&id=4236fcd5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4236fcd5"]])

export default __exports__